import React, { useEffect, useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function FileThumb({ file }: { file: any }) {
  const [url, setUrl] = useState("");
  const [err, setErr] = useState(false);
  useEffect(() => {
    let u = "";
    api.get(`/files/${file.id}`, { responseType: "blob" })
      .then((r) => { u = URL.createObjectURL(r.data); setUrl(u); })
      .catch(() => setErr(true));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [file.id]);

  const isImg = file.content_type?.startsWith("image/");
  return (
    <a href={url || undefined} target="_blank" rel="noreferrer" data-testid={`challan-file-${file.id}`}
      className="block w-32 rounded-lg border border-slate-200 overflow-hidden bg-slate-50 hover:border-blue-400">
      <div className="h-24 grid place-items-center">
        {err ? <span className="text-xs text-red-500">লোড হয়নি</span> : !url ? <Loader2 className="animate-spin text-slate-400" size={18} />
          : isImg ? <img src={url} alt={file.original_filename} className="w-full h-full object-cover" /> : <FileText className="text-red-500" size={32} />}
      </div>
      <p className="text-[11px] px-2 py-1 truncate border-t border-slate-200 bg-white">{file.original_filename}</p>
    </a>
  );
}
